<div class="w-100 h-100 margin-xxl--right-16">
  <div class="font--xxl-18 font-500 color-sky-blue">
    <div class="font--xxl-18 font-500 color-sky-blue">
      {{ !existingAddress ? 'Add new "Ship From" Location' : "View/Update 'Ship From' location" }}
    </div>
  </div>
  <div class="line margin-xxl--top-24"></div>
  <div class="flex flex-column border--right-bg-gray container-form">
    <div class="flex align-items-start justify-content-start margin-xxl--bottom-70 margin-xxl--top-24">
      <div class="flex align-items-center margin-xxl--right-24">
        <div class="radio border-grey-line margin-xxl--right-12 cursor-pointer" (click)="isDomesticLoad = true">
          <div
            class="radio-inside"
            [ngClass]="{
              'background-turquoise--dark': isDomesticLoad,
              'background-white': !isDomesticLoad
            }"
          ></div>
        </div>
        <input type="radio" id="post_code" />
        <label
          for="post_code"
          class="font--xxl-12"
          [ngClass]="{
            'color-dark-blue': isDomesticLoad,
            'color-body-text': !isDomesticLoad
          }"
          >Post Code</label
        >
      </div>
      <div class="flex align-items-center">
        <div class="radio border-grey-line margin-xxl--right-12 cursor-pointer" (click)="isDomesticLoad = false">
          <div
            class="radio-inside"
            [ngClass]="{
              'background-turquoise--dark': !isDomesticLoad,
              'background-white': isDomesticLoad
            }"
          ></div>
        </div>
        <input type="radio" id="address" /><label
          for="address"
          class="font--xxl-12"
          [ngClass]="{
            'color-dark-blue': !isDomesticLoad,
            'color-body-text': isDomesticLoad
          }"
          >Address</label
        >
      </div>
    </div>
    <div class="flex flex-column margin-xxl--bottom-16 margin-xxl--right-32">
      <div class="font--xxl-11 color-body-text font-regular">Location Name</div>
      <input
        class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
        [(ngModel)]="name"
        (ngModelChange)="onNameChange()"
        type="text"
        autocomplete="new-password"
        [disabled]="!isEdit"
      />
    </div>
    <div class="flex flex-column margin-xxl--bottom-16">
      <div class="font--xxl-11 color-body-text font-regular">Postal code</div>
      <app-select-typeahead
        [input_value]="postCodes"
        [exsisting_value]="address.postalCode"
        [placeholder]="''"
        [objectKey]="'postalCode'"
        [objectValue]="'postalCode'"
        [isDisabled]="!isDomesticLoad || !isEdit"
        [inputWidth]="'9'"
        [returnWholeObject]="true"
        (emmiterReturnValue)="getAddress($event)"
        (emmiterReturnString)="getPostalCodeSuggestions($event)"
        [inputStyle]="
          'input-large font--xxl-13 color-dark-blue font-regular border-grey-bluish ' +
          (!isDomesticLoad ? 'background-background-blue-dark-imp' : '')
        "
      ></app-select-typeahead>
    </div>
    <div class="flex flex-column margin-xxl--bottom-16">
      <div class="font--xxl-11 color-body-text font-regular">Address</div>
      <app-select-typeahead
        appDebounce
        [input_value]="suggestions"
        [exsisting_value]="existingAddress"
        [isDisabled]="isDomesticLoad || !isEdit"
        [placeholder]="''"
        [objectKey]="'href'"
        [objectValue]="'title'"
        [inputWidth]="'20'"
        [returnWholeObject]="true"
        (emmiterReturnValue)="getAddress($event)"
        (emmiterReturnString)="getSuggestions($event)"
        [inputStyle]="
          'input-large  font--xxl-13 color-dark-blue font-regular border-grey-bluish ' +
          (isDomesticLoad ? 'background-background-blue-dark-imp' : '')
        "
      ></app-select-typeahead>
    </div>
    <div class="flex flex-column margin-xxl--bottom-16">
      <div class="font--xxl-11 color-body-text font-regular">Exact Address</div>
      <input
        class="input-large border-grey-bluish font--xxl-13 color-dark-blue font-regular"
        [disabled]="!isEdit"
        [(ngModel)]="address.note"
        type="text"
      />
    </div>
  </div>
</div>
